var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngineering2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1686.478,
    height: 60.9,
    viewBox: "0 0 1686.478 60.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Engineering_2",
    transform: "translate(-0.522 -23.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139428",
    "data-name": "\\uD328\\uC2A4 139428",
    d: "M.522-60.9v13.311h11.31V0H29.058V-60.9Z",
    transform: "translate(0 84)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1658",
    "data-name": "\\uC120 1658",
    d: "M1633.061,1H0V-1H1633.061Z",
    transform: "translate(48 65.324)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21795",
    "data-name": "\\uD0C0\\uC6D0 21795",
    cx: 5.939,
    cy: 5.939,
    rx: 5.939,
    ry: 5.939,
    transform: "translate(1675.121 59.385)",
    fill: "#1876d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering2);
export default __webpack_public_path__ + "static/media/Engineering_2.1e1ef3f700032f4018679300db6a5912.svg";
export { ForwardRef as ReactComponent };